import React, { useEffect } from 'react'
import { Box, Radio } from '@material-ui/core'
import CurrencyFormat from 'react-currency-format'

const OrderGroupRadio = ({
  groupId,
  options,
  selectedValue,
  setSelectedValue,
  singleProductOrder,
}) => {
  useEffect(() => {
    handleDefault()
  }, [options])

  const handleDefault = () => {
    const groupInfo = singleProductOrder.groups.find(
      (group) => group.key === groupId,
    )

    //Si ya el pedido existe
    if (groupInfo.options.length) {
      groupInfo.options.forEach((option) => setSelectedValue(option.key))
    } else {
      options.forEach((option) => {
        if (option.isDefault) {
          setSelectedValue(option.key)
        }
      })
    }
  }

  return (
    <>
      {options.map((option) => (
        <Box key={option.key} display="flex" alignItems="center">
          <Radio
            name="group"
            value={option.key}
            checked={selectedValue === option.key}
            onChange={(event) => setSelectedValue(event.target.value)}
          />
          <Box display="flex" justifyContent="space-between" width="100%">
            <span>{option.name}</span>
            {option.isExtra && (
              <CurrencyFormat
                value={option.price}
                displayType="text"
                thousandSeparator
                prefix="$"
              />
            )}
          </Box>
        </Box>
      ))}
    </>
  )
}

export default OrderGroupRadio
